// Central data source for BRA Sheriff Builders and Developers landing page

export const brandLogo =
    "images/Icon_NoBG.png";

export const brand = {
    name: "BRA Sheriff",
    fullName: "BRA Sheriff Builders and Developers",
    tagline: "Building Landmarks. Creating Legacies.",
    founded: 1984,
    phone: "+91 98869 03121",
    phoneRaw: "919886903121",
    email: "usman@brabuilders.in",
    address: {
        line1: "No. 106/A, Ground Floor",
        line2: "Langford Road, Opposite Nanjappa Circle",
        line3: "Shanti Nagar, Bangalore – 560025",
    },
    hours: "Mon – Sat  ·  10:00 — 20:00",
    social: {
        instagram: "#",
        facebook: "#",
        linkedin: "#",
    },
};

export const heroStats = [
    { value: "50+", label: "Completed Projects" },
    { value: "40+", label: "Years of Excellence" },
    { value: "100%", label: "Commitment to Quality" },
    { value: "BLR", label: "Based Developers" },
];

export const timeline = [
    { year: "1924", label: "Family Legacy Begins" },
    { year: "1984", label: "BRA Sheriff Founded" },
    { year: "1985", label: "First Residential Project" },
    { year: "2010", label: "Expansion into Apartments" },
    { year: "Today", label: "Premium Residential & Mixed Use" },
];

export const companyStats = [
    { value: 50, suffix: "+", label: "Completed Projects" },
    { value: 40, suffix: "+", label: "Years Experience" },
    { value: 100, suffix: "+", label: "Happy Families" },
    { value: 1984, suffix: "", label: "Established" },
];

export const services = [
    {
        n: "01",
        title: "Apartment Developments",
        body: "Modern residential communities engineered for comfort, longevity and lasting value.",
    },
    {
        n: "02",
        title: "Luxury Villas",
        body: "Bespoke villa developments with elegant architecture and refined finishes.",
    },
    {
        n: "03",
        title: "Commercial Buildings",
        body: "Contemporary office and retail developments in Bangalore’s prime corridors.",
    },
    {
        n: "04",
        title: "Property Development",
        body: "Land development and end-to-end project execution — from acquisition to delivery.",
    },
    {
        n: "05",
        title: "Construction Management",
        body: "Professional planning, supervision and rigorous quality assurance.",
    },
    {
        n: "06",
        title: "Real Estate Promotion",
        body: "Trusted development partnerships built on transparent, disciplined execution.",
    },
];

export const featuredProjects = [
    { no: 1, name: "Sheriff Apartment", type: "Residential Apartments", location: "Serpentine Street", year: 1984 },
    { no: 2, name: "Sheriff Pearl", type: "Residential Apartments", location: "Berlie Street", year: 1990 },
    { no: 3, name: "GKS Plaza", type: "Commercial Complex", location: "Tank Garden", year: 2000 },
    { no: 4, name: "Sheriff Elegant", type: "Residential Apartments", location: "Arkare Layout", year: 2002 },
    { no: 5, name: "BHR Sheriff Complex", type: "Commercial Complex", location: "Shanti Nagar", year: 2002 },
    { no: 6, name: "BHR Sheriff Complex", type: "Commercial Complex", location: "Siddaiah Road", year: 2005 },
    { no: 7, name: "Ashiyana Apartments", type: "Residential Apartments", location: "Indiranagar", year: 2005 },
    { no: 8, name: "NGS School", type: "School", location: "Shanti Nagar", year: 2006 },
    { no: 9, name: "Shabana Mansion", type: "Residential Apartments", location: "Victoria Layout", year: 2006 },
    { no: 10, name: "Sheriff Commercial Complex", type: "Commercial Complex", location: "Jaali Mohalla", year: 2008 },
    { no: 11, name: "Nasru Manzil", type: "Residential Apartments", location: "Neelsandra", year: 2010 },
    { no: 12, name: "BHR Sheriff Plaza", type: "Residential Apartments", location: "Lakasandra", year: 2011 },
    { no: 13, name: "Commercial Building", type: "Commercial Complex", location: "Kalasipalyam", year: 2015 },
    { no: 14, name: "Rahman Manzil", type: "Residential Apartments", location: "Shivaji Nagar", year: 2017 },
    { no: 15, name: "Ashiyana Sheriff Apartments", type: "Residential Apartments", location: "Sarjapur Road", year: 2020 },
    { no: 16, name: "BRA Sheriff Plaza", type: "Residential Apartments", location: "Shanti Nagar", year: 2021 },
    { no: 17, name: "Bungalow 38", type: "Independent House", location: "Shantinagar", year: 2023 },
];

export const ongoing = [
    {
        name: "Sheriff Residency",
        location: "Electronic City",
        stage: "Foundation",
        pct: 25,
        img: "images/construction-workers-building-foundation-house.jpg",
    },

];

export const journey = [
    "Land Acquisition",
    "Planning",
    "Architectural Design",
    "Government Approvals",
    "Construction",
    "Quality Inspection",
    "Project Delivery",
];

export const whyChoose = [
    {
        n: "01",
        title: "40 Years Experience",
        body: "Four decades of trusted development across Bangalore.",
    },
    {
        n: "02",
        title: "Premium Quality",
        body: "Superior construction standards, uncompromising materials.",
    },
    {
        n: "03",
        title: "Transparent Process",
        body: "Clear documentation and open communication throughout.",
    },
    {
        n: "04",
        title: "Timely Delivery",
        body: "Disciplined milestones. Handover on the promised date.",
    },
    {
        n: "05",
        title: "Experienced Leadership",
        body: "Professionally managed by a second-generation director.",
    },
    {
        n: "06",
        title: "Customer First",
        body: "Long-term relationships built on trust and service.",
    },
];

export const galleryImages = [
    "images/closeup-construction-worker-placing-tiles.jpg",
    "images/construction-site-showing-foundation-framework-with-gravel-dirt-piles-preparing-building-development-urban-area.jpg",
    "images/high-angle-view-construction-site.jpg",
    "images/new-home-foundation-construction-progress-cement-retaining-walls-place-cement-poured.jpg",
    "images/rusty-metal-grid-texture.jpg",
    "images/stack-cement-blocks-construction-site.jpg",
    "images/steel-bar-site-construction.jpg",
    "images/workers-construction-site.jpg",
    "images/working-hard-building-man-construction-worker.jpg",
    "images/luxury-house-renovation.jpg",

];

export const testimonials = [
    {
        stars: 5,
        quote: "BRA Sheriff delivered exactly what they promised. The workmanship, finishing and professionalism exceeded our expectations.",
        author: "Meera Krishnan",
        role: "Homeowner, Richmond Town",
    },
    {
        stars: 5,
        quote: "A trustworthy builder with excellent attention to detail. Every promise made was honoured on the ground.",
        author: "Arjun Rao",
        role: "Homeowner, Shanti Nagar",
    },
    {
        stars: 5,
        quote: "From booking to possession, the entire process was transparent, timely, and hassle-free.",
        author: "Fathima Zainab",
        role: "Homeowner, Langford Road",
    },
];

export const founder = {
    name: "Late Dr. B. R. Ahmedulla Sheriff",
    role: "Founder — 1984",
    img: "images/BRA_uncle.jpeg",
};

export const director = {
    name: "Mr. B. A. Usman Sheriff",
    role: "Project Executive & Director",
    img: "images/Usman_profile2.png",
    quote: "Every project we undertake is built with the same commitment to quality, trust and integrity that our founder envisioned over four decades ago.",
};

export const projectTypes = [
    "Apartment",
    "Villa",
    "Commercial",
    "Land Development",
    "Consultation",
];

export const budgetRanges = [
    "Under ₹1 Cr",
    "₹1 – ₹2 Cr",
    "₹2 – ₹5 Cr",
    "₹5 Cr +",
    "Not sure yet",
];

// Blueprint transition assets
export const blueprintImage =
    "images/architectural-blueprint-multilevel-building-progress.jpg";
export const finishedImage =
    "images/arch_finished.png";

// Family heritage — parent company since 1924
export const heritage = {
    parentCo: "B. H. Rahaman Sheriff and Sons",
    established: 1924,
    specialty: "Engine Rebuilding",
    founder: "Mr. B. H. Rahaman Sheriff",
    address: "#2H Siddaiah Road, BHR Sheriff Complex, Bangalore — 560025",
    achievement:
        "Made the first lathe machine in South India — awarded and preserved at the Visvesvaraya Industrial & Technological Museum, Bangalore.",
    generations: [
        {
            n: "I",
            year: "1924",
            role: "The Founder",
            people: ["Mr. B. H. Rahaman Sheriff"],
            note: "Pioneer engine rebuilder. Built and was awarded for the first lathe machine in South India — today preserved at the Visvesvaraya Museum, Bangalore.",
        },
        {
            n: "II",
            year: "1960s — 1990s",
            role: "The Custodians",
            people: [
                "Mr. B. R. Amanulla Sheriff",                
                "Mr. B. R. Ahmedulla Sheriff",
                "Mr. B. R. Inayathulla Sheriff",
                "Mr. B. R. Asifulla Sheriff",
            ],
            note: "Expanded the family enterprise from engine works into hardware, real estate development and construction across Bangalore.",
        },
        {
            n: "III",
            year: "Today",
            role: "The Continuation",
            people: [
                "Mr. B. A. Omer Sheriff",               
                "Mr. B. A. Usman Sheriff",
                "Mr. B. N. Sufiyan Sheriff",
                "Mr. B. A. Zaib Sheriff",
            ],
            note: "The third generation carries the family name across builders, developers and the paints & hardware trade — with the same standard of trust.",
        },
    ],
};

// BHR Paints & Hardware — sister business
export const hardware = {
    name: "B. H. R. Paints & Hardware",
    tagline: "One shop. Every material.",
    description:
        "Authorised dealer for Asian Paints, UltraTech Cement, Birla, CP Fittings, sanitary ware, PVC & CPVC pipes and fittings — and every branded product a project needs.",
    address: "Shanthinagar, Bangalore",
    phones: ["+91 91412 12449", "+91 98869 03121"],
    phonesRaw: ["919141212449", "919886903121"],
    mapLink: "https://share.google/WWIOc8xfQN7EMNyZw",
    // Wikipedia commons brand logo URLs, filtered to monochrome via CSS
    brands: [
        {
            name: "Asian Paints",
            logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b1/Asian_Paints_Logo.svg/2560px-Asian_Paints_Logo.svg.png",
        },
        {
            name: "UltraTech Cement",
            logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/8/86/UltraTech_Cement_Logo.svg/2560px-UltraTech_Cement_Logo.svg.png",
        },
        {
            name: "Birla White",
            logo: "https://upload.wikimedia.org/wikipedia/en/thumb/9/9f/Birla_White_logo.png/220px-Birla_White_logo.png",
        },
        {
            name: "CP Fittings",
            logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/66/Chase_Plumbing_Logo.png/220px-Chase_Plumbing_Logo.png",
        },
        {
            name: "Astral Pipes",
            logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a8/Astral_Ltd._logo.png/220px-Astral_Ltd._logo.png",
        },
        {
            name: "Kohler",
            logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fd/Kohler_Co._logo.svg/2560px-Kohler_Co._logo.svg.png",
        },
    ],
    // Fallback: pure text marks used if the logos above 404 (rendered together, brand still readable)
    brandNames: [
        "Asian Paints",
        "UltraTech Cement",
        "Birla White",
        "CP Fittings",
        "Astral Pipes",
        "Kohler",
        "Sintex",
        "Bosch",
    ],
    image:
        "images/construction-site-with-building-materials-scaffolding-structures.jpg",
};
